import EditBrandPartnershipContainer from "../containers/EditBrandPartnershipContainer";

const EditBrandPartnershipPage = () => {
  return (
    <EditBrandPartnershipContainer />
  );
};

export default EditBrandPartnershipPage;
